import React from "react";
import OffcanvasWrapper from "../component/OffcanvasWrapper";
import { Button, FloatingLabel, Form } from "olive-react-myoneui";
import DropdownCommon from "../component/DropdownCommon";

const AddEditOffcanvas = ({
  show,
  onClose,
  type,
  handleChange,
  title,
  selectedSubtopic,
  subTopics,
  setSelectedSubtopic,
  searchValue,
  setSearchValue,
  hasMore,
  handleLoadMore,
  isLoading,
  onSubmit,
  onButtonLoading,
  errors = {},
}) => {
  return (
    <OffcanvasWrapper
      show={show}
      onClose={onClose}
      title={`${type === "edit" ? "Edit" : "add" ? "Add" : ""} Chapters`}
      footer={
        <>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            {onButtonLoading ? "Saving..." : "Save"}
          </Button>
        </>
      }
    >
      <p className="help-text fs-6 fw-semibold">
        Please enter the chapter title and select the sub-topic(s) below.
      </p>
      <div className="mb-4">
        <FloatingLabel controlId="chapterId" label={<span className={errors?.title && "text-danger"}>Title *</span>}>
          <Form.Control
            type="text"
            placeholder="title"
            name="title"
            value={title}
            onChange={handleChange}
            isInvalid={!!errors?.title}
          />
        </FloatingLabel>
        {errors?.title && <div className="text-danger mt-1">{errors.title}</div>}
      </div>
      <div className="mb-4">
        <DropdownCommon
          name="selectedSubtopic"
          selectedValue={selectedSubtopic}
          setSelectedValue={setSelectedSubtopic}
          items={subTopics}
          label={<span className={errors?.subtopic && "text-danger"}>Sub-Topic *</span>}
          searchable={true}
          remoteSearch={true}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          isLoading={isLoading}
        />
        {errors?.subtopic && <div className="text-danger mt-1">{errors.subtopic}</div>}
      </div>
    </OffcanvasWrapper>
  );
};

export default AddEditOffcanvas;
